import React from "react";
import { useSelector } from "react-redux";
import LeaveRequestTable from "../../Usual/HRMS/Components/LeaveRequest/Components/LeaveRequestTable";

const ManagerLeaveRequestView = () => {
  const { hrmsUser, userType } = useSelector((state) => state.auth);
  console.log("HRMS User Data in ManagerLeaveRequestView:", hrmsUser.employee_id);

  const isHotelManager =
    userType === "hrms" &&
    String(hrmsUser?.designation || hrmsUser?.vchDesignation || "")
      .trim()
      .toLowerCase()
      .includes("manager");

  if (!isHotelManager) {
    return (
      <div className="container-fluid">
        <div className="alert alert-warning mt-3 mb-0">
          This page is only available for Manager accounts.
        </div>
      </div>
    );
  }

  const managerName =
    hrmsUser?.name || hrmsUser?.vchFullName || hrmsUser?.employeeName || "";

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body leave-management-page leave-module-shell">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="leave-page-header d-flex align-items-start justify-content-between flex-wrap gap-3">
            <div>
              <span className="leave-page-kicker">Leave Approval</span>
              <h3 className="fw-bold mb-1 leave-page-title">Staff Leave Requests</h3>
              <p className="mb-0 leave-page-description">
                Review and act on your staff's leave applications.
              </p>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card leave-surface-card">
            <div className="card-body leave-surface-body">
              <LeaveRequestTable managerScope managerName={managerName} managerId={hrmsUser.employee_id} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagerLeaveRequestView;
